const StatCard = ({ icon: Icon, label, value, sublabel, variant = 'default' }) => {
    const variants = {
        default: 'bg-white border-gray-100',
        primary: 'bg-primary/5 border-primary/20',
        success: 'bg-success/5 border-success/20',
    };

    const iconVariants = {
        default: 'bg-gray-100',
        primary: 'bg-primary/10',
        success: 'bg-success/10',
    };

    const iconColors = {
        default: 'text-gray-600',
        primary: 'text-primary',
        success: 'text-success',
    };

    return (
        <div className={`rounded-2xl border p-5 shadow-card ${variants[variant]}`}>
            <div className="flex items-center gap-3 mb-3">
                <div className={`p-2 rounded-xl ${iconVariants[variant]}`}>
                    <Icon className={`w-5 h-5 ${iconColors[variant]}`} />
                </div>
                <span className="text-sm font-medium text-gray-500">{label}</span>
            </div>
            <p className="text-2xl font-bold text-gray-900">{value}</p>
            {sublabel && <p className="text-sm text-gray-500 mt-1">{sublabel}</p>}
        </div>
    );
};

export default StatCard;
